import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'

const BUTTON_SELECTOR = '[data-back-to-top-button]'

export class BackToTopButton extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'click', this.handleButtonClick)
    this.addListener(window, 'scroll', this.handleWindowScroll)
  }

  handleWindowScroll = (): void => {
    const button = $el(BUTTON_SELECTOR, this)
    button?.classList.toggle('is-visible', window.scrollY > window.innerHeight)
  }

  handleButtonClick = (): void => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
